import React, { useState, useEffect } from "react";
import { Container, Grid, makeStyles, Typography } from "@material-ui/core";
import ReactPlayer from "react-player";
import { GET_MATERIAL_FILE_BY_SUB_CATEGORY_ID } from "../../../../../quries/material";
import { useQuery } from "@apollo/client";
import VideoLibraryIcon from "@material-ui/icons/VideoLibrary";
import GalleryFileList from "./GalleryFileList";
import MetaSeo from "../../../../MetaSeo";

interface MaterialSectorProps {
  //   rowData: any;
  materialId: number;
}

const useStyles = makeStyles((theme) => ({
  fileContainer: {
    padding: 24,
    [theme.breakpoints.down("xs")]: {
      padding: 0,
      paddingBottom: 16,
    },
  },
  categoryTitle: {
    fontSize: 24,
    fontWeight: 900,
    fontFamily: "Noto Sans KR",
    [theme.breakpoints.down("xs")]: {
      paddingBottom: 0,
    },
  },
}));

function FileGallery({ materialId }: MaterialSectorProps) {
  const classes = useStyles();
  const [fileArray, setFileArray] = useState<any>(null);
  const { data, loading, error } = useQuery(
    GET_MATERIAL_FILE_BY_SUB_CATEGORY_ID,

    {
      fetchPolicy: "no-cache",

      variables: {
        where: {
          archive_sub_category: {
            id: materialId,
          },
        },
      },
    }
  );

  useEffect(() => {
    if (data && data.materialFiles) {
      if (data.materialFiles.length > 0) {
        setFileArray(data.materialFiles);
      }
    }
    return () => {
      setFileArray(null);
    };
  }, [data, materialId]);

  if (loading) return null;
  if (data === undefined) return null;
  if (error || !data.materialFiles) {
  }

  return (
    <Container maxWidth={false} disableGutters={true}>
      <Grid alignItems="center" justify="center" xs={12} container item>
        {fileArray ? (
          <React.Fragment>
            <Grid xs={12} item>
              {/* <VideoLibraryIcon /> */}
              <p
               className={classes.categoryTitle}
              >
                파일 자료
              </p>
            </Grid>
            <Grid xs={12} item container>
              {fileArray.map((file: any, index: any) => {
                return (
                  <Grid
                    xs={12}
                    sm={12}
                    style={{ padding: 24 }}
                    item
                    key={`file-gallery-${file.title}-${index}`}
                  >
                    <Typography
                      variant="subtitle1"
                      gutterBottom
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        fontFamily: "Noto Sans KR",
                        fontWeight: 600,
                        paddingBottom: 16,
                      }}
                    >
                      {file.title}
                    </Typography>
                    <GalleryFileList fileArray={file.file} />

                    {/* <ReactPlayer
                        url={`${video.video_url}`}
                        width="100%"
                        height="240px"
                        controls={true}
                      /> */}
                  </Grid>
                );
              })}
            </Grid>
          </React.Fragment>
        ) : (
          <div></div>
        )}
      </Grid>
    </Container>
  );
}
export default FileGallery;
